import { Component } from "./base/copmonent";
import { createElement, ensureElement } from "../utils/utils";
export class Basket extends Component {
    constructor(container, events) {
        super(container);
        this.events = events;
        this._list = ensureElement('.basket__list', this.container);
        this._price = this.container.querySelector('.basket__price');
        this._button = this.container.querySelector('.basket__button');
        this.items = [];
        this._button.disabled = true;
        if (this._button) {
            this._button.addEventListener('click', () => {
                events.emit('order:open');
            });
        }
    }
    set items(items) {
        if (items.length) {
            this._list.replaceChildren(...items);
        }
        else {
            this._list.replaceChildren(createElement('p', {
                textContent: 'Корзина пуста'
            }));
        }
    }
    set total(price) {
        this.setText(this._price, `${price.toString()} синапсов`);
        ;
    }
    buttonBlocked(isDisabled) {
        this._button.disabled = isDisabled;
    }
}
